import React, { Component } from 'react';
import ConfigurationService from './services/Configuration.service';
import CookieBannerConfiguration from './models/CookieBannerConfiguration';
import CookieBannerPage from './views/pages/CookieBannerPage'
import Cookies from 'universal-cookie';

type AppProps = {
  homePageId: string;
}

type AppState = {
  configuration: CookieBannerConfiguration,
  enableManagement: boolean,
  consentConfigured: any
}

export default class App extends Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      configuration: new CookieBannerConfiguration(),
      enableManagement: false,
      consentConfigured: new Cookies().get('cookieConsent')
    };
  }

  public async componentDidMount() {
    const service: ConfigurationService = new ConfigurationService();
    const configuration: CookieBannerConfiguration = await service.getConfiguration(this.props.homePageId);

    this.setState({
      configuration: configuration
    });
  }

  public consentChanged(): void {
    this.setState({
      consentConfigured: true
    });
  }

  public render() {
    return (
      <>
        {
          !this.state.consentConfigured &&
          <div className="c-cookiebanner">
            <CookieBannerPage configuration={this.state.configuration} consentConfigured={() => { this.consentChanged(); }}></CookieBannerPage>
          </div>
        }
      </>
    );
  }
}